/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.GiftCardTypes {
    angular.module("meevo.plugins.giftCardTypes", []);
}